module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-chrome"
  }, [(_vm.isLoadingCurrentUser || _vm.isLoading) ? _c('loading-indicator') : _c('div', [(_vm.isUnauthorize) ? _c('page403') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a32d44e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/payments/PaymentResponse.vue
// module id = 508
// module chunks = 1